import { IReconciliation } from '@nkr/models/index';

export const mockData: IReconciliation = {
    "items": [
        {
            "transplantDate": "2020-09-24",
            "donorAlias": "",
            "firstName": "Jane",
            "lastName": "Doe",
            "birthDate": "1955-03-23",
            "matches": [
                {
                    "id": 28664,
                    "firstName": "Jane",
                    "lastName": "Doe",
                    "birthDate": "1955-03-23",
                    "transplantDate": "2019-09-12",
                    donationType: 0,
                    donationTypeDescription: '',
                    "matchType": 1
                }
            ]
        },
        {
            "transplantDate": "2020-01-31",
            "donorAlias": "",
            "firstName": "Steven",
            "lastName": "Janofsky",
            "birthDate": "1964-07-18",
            "matches": [
                {
                    "id": 17747,
                    "firstName": "Donald",
                    "lastName": "Thompson",
                    "birthDate": "1964-07-18",
                    "transplantDate": "2019-05-01",
                    donationType: 1,
                    donationTypeDescription: '',
                    "matchType": 2
                }
            ]
        },
        {
            "transplantDate": "2020-04-06",
            "donorAlias": "",
            "firstName": "Jack",
            "lastName": "Wagner",
            "birthDate": "1970-07-04",
            "matches": [
                {
                    "id": 31044,
                    "firstName": "Barbara",
                    "lastName": "Williams",
                    "birthDate": "1970-07-04",
                    "transplantDate": "2018-12-20",
                    donationType: 2,
                    donationTypeDescription: '',
                    "matchType": 2
                }
            ]
        }
    ],
    "invalidRows": []
}